<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<p-table #mdmTagSystemTable [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    <div class="d-flex flex-row justify-content-between">
        <div>
          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" style="height: 35px;" label="Add"></button>
        </div>
        <div >
            {{title}}
        </div>
        <div >
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Search" (input)="mdmTagSystemTable.filterGlobal($event.target.value, 'contains')" style="width:auto;height: 35px;">
        </div>
    </div>
</ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'active' && col.field != 'lab'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active' ">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>


<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade"
  [modal]="true" [style.width]="'800px'"[dismissableMask]="true" position="top" maximizable="true" [baseZIndex]="10000">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <label>{{col.header}}</label>
        <div *ngIf="col.field == 'tagSystemName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" [ngClass]=" { 'disableTextBox' : isTagSystemName(col.field) }"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
            <div class="pt-2 pr-0 pl-0 pb-2">
                <p-fileUpload #fileUploader (onUpload)="ontagPlatesUpload($event, fileUploader)" mode="basic" customUpload="true" accept=".xlsx" 
                chooseLabel="Upload new Tag Plates" (onSelect)="ontagPlatesUpload($event, fileUploader)" [disabled]="isSaveDisabled()" auto="true"></p-fileUpload>
                <br>{{uploadedFileName}}
            </div>
            <div class="pt-2 pr-0 pl-0 pb-2">
                <button type="button" pButton icon="pi pi-download" [disabled]="disableDownloadTagsButton" style="height: 35px;" label="Download All Tags"></button>
            </div>
            <div class="pt-2 pr-0 pl-0 pb-2">
                <button type="button" pButton icon="pi pi-download" [disabled]="disableDownloadPlateButton" style="height: 35px;" label="Download Plate Info"></button>
            </div>
        </div>
        <div *ngIf="col.field == 'active'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
    
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" style="height: 35px; margin: 1%;" (click)="saveMasterList()"
      label="Save" class="float-right"></button>
  </div>

</p-dialog>